import { render, staticRenderFns } from "./mNotice.vue?vue&type=template&id=da05a644"
import script from "./mNotice.vue?vue&type=script&lang=js"
export * from "./mNotice.vue?vue&type=script&lang=js"
import style0 from "./mNotice.vue?vue&type=style&index=0&id=da05a644&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports